import { ASSETS } from "@/lib/site";

export const Logo = ({ size = 48 }) => (
    <img
        src={ASSETS.logoSmall}
        alt="KischioWood — Aus dem Wald direkt in den Ofen"
        style={{ height: size, filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.5))" }}
        className="w-auto"
    />
);
